Bingo.DeveloperProjectDetail = {};

Bingo.DeveloperProjectDetail.init = () => {
    if (window.matchMedia('(max-width: 767px)').matches) {
        $('.variable-heading').prependTo('#developer-project-detail');
    }
    if (window.matchMedia('(min-width: 421px)').matches) {
        // ad class when needed
        $('#swiper-more-projects .swiper-wrapper-backup').addClass('swiper-wrapper');
        // init swiper
        new Swiper('#swiper-more-projects .swiper-container', {
            pagination: '#swiper-more-projects .swiper-pagination',
            slidesPerView: 1,
            paginationClickable: true,
            loop: false,
            navigation: {
                nextEl: '#swiper-more-projects .swiper-to-right',
                prevEl: '#swiper-more-projects .swiper-to-left',
            },
            spaceBetween: 30,
            speed: 850,
            centeredSlides: true,
            breakpoints: {
                1200: {
                    slidesPerView: 2,
                    centeredSlides: false,
                },
            },
        });
    } else {
        // remove class what styling swiper
        $('#js-swiperSimilarOffers .swiper-wrapper').addClass('swiper-wrapper-backup').removeClass('swiper-wrapper');
    }

    Bingo.OfferDetail.gallerySwiper('js-galleryDetailSwiper');

    $(window).resize(() => {
        Bingo.OfferDetail.gallerySwiper('js-galleryDetailSwiper');
    });

    $('.js-mapOnDetail__buttonFullMapMobileShow').click(() => {
        $('body').addClass('-offerDetailFullscreen');
    });

    $('.js-mapOnDetail__buttonFullMapMobileHide').click(() => {
        $('body').removeClass('-offerDetailFullscreen');
    });

    $('.js-mapOnDetail__buttonFullMapTabletAndDesktop').click(function () {
        $(this).remove();
        $('.js-offerDetail__columnGallery').addClass('d-md-none');
        $('.js-offerDetail__columnLocation').removeClass('pl-md-0').addClass('col-md-12 -showMapControlsOnTabletAndDesktop');
        $('.js-offerDetail__locationGalleryTrigger').removeClass('d-md-none').addClass('d-md-block');
    });
};
